@if (suboptionChoices) {
  @for (suboptionChoice of suboptionChoices; track trackBySuboptionChoice($index, suboptionChoice)) {
    <div class="suboption">
      <app-client-configuration-suboption
        [suboptionTypeChoices]="suboptionTypeChoices"
        [suboptionChoices]="suboptionChoices"
        [suboptionChoice]="suboptionChoice"
        [definition]="definition"
        (choiceChange)="onChoiceChange($event)"
        (choiceRemove)="onChoiceRemove($event)"
        />
    </div>
  }
  @if (canAdd) {
    <div class="small">
      <a href="#" (click)="onAddClick($event)">
        <fa-icon [icon]="['fas', 'plus-circle']" size="1x" />
        Add {{ suboptionTypeDescriptions[definition.suboptionType] }}
      </a>
    </div>
  }
}
